export default __webpack_public_path__ + "device_hexa.d0a6639c.png";